<div [ngClass]="{ 'active' : active, 'disabled': linkStatus }" class="wrap">
  <div class="header" [ngClass]="{ 'showWarning': showWarning }">
    <!-- Avatar -->
    <app-avatar *ngIf="linkStatus === 'INVITED'" class="user-avatar" [initials]="initials.toUpperCase()"></app-avatar>
    <app-avatar *ngIf="picture && linkStatus !== 'INVITED'" class="user-avatar" [picture]="picture"></app-avatar>
    <span *ngIf="showWarning" class="warning icon-warning"></span>
  </div>
  <!-- Content -->
  <div class="content">
    <div *ngIf="!linkStatus" class="user-name">
      {{ firstName }} 
      <br>
      {{ lastName }}
    </div>
    <div *ngIf="linkStatus === 'PENDING' || linkStatus === 'INVITED'" class="linkStatus">
      {{ 'pages.user-cards.familyLink.linkStatus.PENDING' | translate }}
    </div>
  </div>
</div>